export const conactsApiServer = ''

export const domainName = 'myenergy.stream'
export const altDomainName = 'my-energy-landing.itfox-web.com'

// export const domainName = 'localhost:3000'
// export const altDomainName = '192.168.88.163:3000'
